var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLifebuoyAddCircle = function SvgLifebuoyAddCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1133_34732)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8514 72.1518C83.6216 65.4644 87.0991 56.7517 87.0991 47.2365C87.0991 37.7214 83.6216 29.0469 77.8514 22.3595C76.6285 20.8692 75.2529 19.5317 73.8007 18.3089C67.1516 12.5004 58.4389 9.02295 48.8855 9.02295C39.3703 9.02295 30.6958 12.5004 24.0084 18.2706C22.5563 19.4935 21.1806 20.8692 19.9578 22.3213C14.1493 29.0087 10.6719 37.7214 10.6719 47.2365C10.6719 56.7517 14.1493 65.4644 19.9196 72.1518C21.1806 73.6039 22.5181 74.9414 23.9702 76.2025C30.6576 81.9727 39.3703 85.4501 48.8855 85.4501C58.4389 85.4501 67.1516 81.9727 73.8007 76.1642C75.2529 74.9796 76.5903 73.6039 77.8514 72.1518ZM49.0005 59.3596C55.6958 59.3596 61.1234 53.9319 61.1234 47.2366C61.1234 40.5413 55.6958 35.1137 49.0005 35.1137C42.3052 35.1137 36.8775 40.5413 36.8775 47.2366C36.8775 53.9319 42.3052 59.3596 49.0005 59.3596Z",
    fill: "url(#paint0_linear_1133_34732)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6549 71.2189L62.9486 57.5125C64.9739 54.6847 66.1967 51.2454 66.1967 47.5005C66.1967 43.7556 64.9739 40.3163 62.9486 37.4885L76.6851 23.7872C77.347 23.127 77.4036 22.0679 76.7679 21.3824C76.2174 20.7888 75.6436 20.2205 75.0521 19.6746C74.3593 19.0351 73.2891 19.0849 72.6224 19.7516L58.8979 33.4761C56.0701 31.489 52.6691 30.3044 49.0006 30.3044C45.2556 30.3044 41.8164 31.5272 38.9886 33.5525L25.1877 19.7164C24.5212 19.0482 23.4503 18.9982 22.7598 19.6416C22.1754 20.1861 21.6083 20.7533 21.0638 21.3377C20.421 22.0276 20.4703 23.0973 21.1371 23.764L34.9762 37.6032C32.9891 40.431 31.8045 43.832 31.8045 47.5005C31.8045 51.169 32.9891 54.57 34.9762 57.3978L21.12 71.2188C20.4443 71.8928 20.4023 72.9781 21.0573 73.6723C21.5945 74.2416 22.1464 74.7935 22.7157 75.3306C23.4093 75.985 24.4934 75.9437 25.1676 75.2695L38.9886 61.4485C41.8164 63.4738 45.2556 64.6966 49.0006 64.6966C52.6691 64.6966 56.0701 63.512 58.8979 61.5249L72.6407 75.2677C73.2998 75.9268 74.3546 75.9836 75.0385 75.3504C75.6157 74.8159 76.175 74.2542 76.7191 73.6735C77.3711 72.9777 77.3292 71.8931 76.6549 71.2189ZM49.0005 59.6236C55.6959 59.6236 61.1235 54.196 61.1235 47.5007C61.1235 40.8054 55.6959 35.3778 49.0005 35.3778C42.3052 35.3778 36.8776 40.8054 36.8776 47.5007C36.8776 54.196 42.3052 59.6236 49.0005 59.6236Z",
    fill: "url(#paint1_linear_1133_34732)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49,
    cy: 93.5,
    rx: 36.5,
    ry: 2.5,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 75,
    r: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 58.25C68.0462 58.25 60.75 65.5462 60.75 74.5C60.75 83.4538 68.0462 90.75 77 90.75C85.9538 90.75 93.25 83.4538 93.25 74.5C93.25 65.5462 85.9538 58.25 77 58.25ZM83.5 75.7188H78.2188V81C78.2188 81.6663 77.6663 82.2188 77 82.2188C76.3337 82.2188 75.7812 81.6663 75.7812 81V75.7188H70.5C69.8337 75.7188 69.2812 75.1663 69.2812 74.5C69.2812 73.8337 69.8337 73.2812 70.5 73.2812H75.7812V68C75.7812 67.3337 76.3337 66.7812 77 66.7812C77.6663 66.7812 78.2188 67.3337 78.2188 68V73.2812H83.5C84.1663 73.2812 84.7188 73.8337 84.7188 74.5C84.7188 75.1663 84.1663 75.7188 83.5 75.7188Z",
    fill: "#448AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1133_34732",
    x1: 56.3794,
    y1: 89.6668,
    x2: 33.2418,
    y2: 18.6527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1133_34732",
    x1: 59.8331,
    y1: 86.639,
    x2: 42.3238,
    y2: 8.34445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68ABFF",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1133_34732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLifebuoyAddCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "lifebuoy-add-circle.2add6e23e4e9e8363ea6622c63d23bcf.svg";